import React, { useEffect, useRef, useState } from "react"
import { Wrapper } from "@googlemaps/react-wrapper"
import classNames from "classnames"

import styles from "./styles.module.scss"
import markerIcon from "./assets/marker.png"
import {useLocalizationContext} from "../../../localization/useLocalizationContext";

interface Props {
	className?: string
}

const Marker = props => {
	const [marker, setMarker] = useState<google.maps.Marker>()

	const localizationContext = useLocalizationContext()

	const markerCoordinates = {
		'ru-RU': { lat: 55.7894, lng: 37.569596 },
		'ru-KZ': { lat: 43.20402700419384, lng: 76.89258163752118 },
		'kz-KZ': { lat: 43.20402700419384, lng: 76.89258163752118 },
		'ru-BY': { lat: 53.91134152987256, lng: 27.51700444714045 },
	}

	const currentCoordinates = markerCoordinates[localizationContext.locale];

	React.useEffect(() => {
		if (!marker) {
			setMarker(new google.maps.Marker())
		}

		return () => {
			if (marker) {
				marker.setMap(null)
			}
		}
	}, [marker])

	React.useEffect(() => {
		if (marker) {
			marker.setOptions({
				position: {  lat: currentCoordinates.lat, lng: currentCoordinates.lng },
				map: props.map,
				icon: markerIcon,
			})
		}
	}, [marker])

	return null
}

const Map = props => {
	const ref = useRef<HTMLDivElement>(null)
	const [map, setMap] = useState<google.maps.Map>()

	const localizationContext = useLocalizationContext()

	interface Coordinates {
		lat: number;
		lng: number;

		mediumLat?: number;
		mediumLng?: number;

		mobileLat?: number;
		mobileLng?: number;
	}

	const coordinates = {
		'ru-RU': {
			lat: 55.78905, lng: 37.564600,

			mediumLat: 55.789346, mediumLng: 37.567098,

			mobileLat: 55.789346, mobileLng: 37.569098,
		} as Coordinates,

		'ru-KZ': {
			lat: 43.20312603295867, lng: 76.89077941233113,
			mobileLat: 43.2042029644967, mobileLng: 76.89260309474861
		} as Coordinates,

		'kz-KZ':  {
			lat: 43.20312603295867, lng: 76.89077941233113,
			mobileLat: 43.2042029644967, mobileLng: 76.89260309474861
		} as Coordinates,

		'ru-BY': {
			lat: 53.91112666040885, lng: 27.513936000240218,
			mobileLat: 53.91134152987256, mobileLng: 27.51700444714045
		} as Coordinates,
	}

	const currentCoordinates = coordinates[localizationContext.locale];


	useEffect(() => {
		if (typeof window !== "undefined") {
			if (ref.current && !map) {
				let center = {  lat: currentCoordinates.lat, lng: currentCoordinates.lng }

				if (window.innerWidth < 1319 && currentCoordinates.mediumLat && currentCoordinates.mediumLng) {
					center = { lat: currentCoordinates.mediumLat, lng: currentCoordinates.mediumLng }
				}

				if (window.innerWidth < 768 && currentCoordinates.mobileLat && currentCoordinates.mobileLng) {
					center = { lat: currentCoordinates.mobileLat, lng: currentCoordinates.mobileLng }
				}

				const googleMap = new window.google.maps.Map(ref.current, {
					mapId: "6afaa0541a9e9872",
					// q: "Quick+Resto:+автоматизация+кафе,+ресторанов+и+баров",
					center,
					zoom: 17,
					disableDefaultUI: true,
				})

				setMap(googleMap)
			}
		}
	}, [ref, map, currentCoordinates])

	return (
		<>
			<div ref={ref} className={styles.map} />
			{React.Children.map(props.children, child => {
				if (React.isValidElement(child)) {
					// @ts-ignore
					return React.cloneElement(child, { map })
				}
			})}
		</>
	)
}

export default function ContactsMap(props: Props) {
	return (
		<div className={classNames(props.className, styles.section)}>
			<Wrapper apiKey={"AIzaSyCLwrQy9ORjL1PFEKCTgzjFqVNG0lE1zU4"}>
				<Map>
					<Marker />
				</Map>
			</Wrapper>
		</div>
	)
}
